import { FieldKey, ICatFormData } from "../types";
import { SignupFlowSlug } from "../constants";

export interface RequiredFieldData {
  cat?: ICatFormData;
  catId?: string;
}

export const requiredFieldsBySlug: Record<
SignupFlowSlug,
(data: RequiredFieldData) => FieldKey[]
> = {
  [SignupFlowSlug.BASIC_INFORMATION]: ({ catId }) => [
    `cat[${catId}].gender`,
    `cat[${catId}].breed`,
  ],

  [SignupFlowSlug.AGE]: ({ cat, catId }) => {
    const base: FieldKey[] = [
      `cat[${catId}].lifeStage`,
      `cat[${catId}].isNeutered`,
      `cat[${catId}].age.mode`,
    ];
    if (cat?.lifeStage === "kitten") {

      const ageMode = cat?.age?.mode ?? "months";
      if (ageMode === "weeks") {
        base.push(`cat[${catId}].age.weeks`);
      } else {
        base.push(`cat[${catId}].age.months`);
      }

    } else {
      // Birthday month is only required for adult/senior cats
      base.push(`cat[${catId}].birthdayMonth`);
      base.push(`cat[${catId}].age.years`);
    }

    return base;
  },

  [SignupFlowSlug.EATING_HABITS]: ({ catId }) => [
    `cat[${catId}].diet.eatingHabits`,
  ],

  [SignupFlowSlug.MOTIVATION]: ({ cat, catId }) => {
    const base: FieldKey[] = [ `cat[${catId}].diet.motivationsForSwitch` ];
    if (cat?.diet?.motivationsForSwitch === "SUPPORTS_HEALTH_CONDITIONS") {
      base.push(`cat[${catId}].diet.healthConcernsToAddress`);
    }
    return base;
  },

  [SignupFlowSlug.FITNESS]: ({ catId }) => [
    `cat[${catId}].body.bodyType`,
    `cat[${catId}].body.activityLevel`,
  ],

  [SignupFlowSlug.WEIGHT]: ({ cat, catId }) => {
    const base: FieldKey[] = [
      `cat[${catId}].weight.unit`,
    ];

    if (cat?.weight?.unit === "LB") {
      base.push(`cat[${catId}].weight.valueInLb`);
    } else {
      base.push(`cat[${catId}].weight.valueInKg`);
    }

    return base;
  },

  [SignupFlowSlug.CURRENT_DIET]: ({ catId }) => [
    `cat[${catId}].diet.current.type`,
    `cat[${catId}].diet.current.brand`,
  ],

  [SignupFlowSlug.MEDICAL_CONDITIONS]: ({ cat, catId }) => {
    const base: FieldKey[] = [ `cat[${catId}].medical.hasConditions` ];
    if (cat?.medical?.hasConditions) {
      base.push(`cat[${catId}].medical.conditions`);
    }
    return base;
  },

  [SignupFlowSlug.ALLERGIES]: ({ cat, catId }) => {
    const base: FieldKey[] = [ `cat[${catId}].diet.foodAllergies.hasAllergies` ];
    if (cat?.diet?.foodAllergies?.hasAllergies) {
      base.push(`cat[${catId}].diet.foodAllergies.allergens`);
    }
    return base;
  },

  [SignupFlowSlug.CAT_PARENT_DETAILS]: () => [
    "firstName",
    "lastName",
    "email",
  ],

  [SignupFlowSlug.CHECKOUT]: () => [
    "firstName",
    "lastName",
    "email",
    "shippingAddress.postcode",
    "shippingAddress.address1",
    "shippingAddress.city",
    "shippingAddress.province",
    "shippingAddress.phoneNumber",
    "billingAddress.postcode",
    "billingAddress.address1",
    "billingAddress.city",
    "billingAddress.countryCode",
    "billingAddress.phoneNumber",
    "deliveryDate",
  ],

  [SignupFlowSlug.PRICING]: () => [
    "deliveryDate",
  ],

  [SignupFlowSlug.RECIPES]: ({ catId }) => [
    `cat[${catId}].viewedPlan`,
  ],
  [SignupFlowSlug.TREATS]: () => [],
  [SignupFlowSlug.CAT_NAMES]: () => [],
};
